<!-- 商标 详情-->
<template>
  <div class="container">
    <div class="banner"></div>
    <div class="main">
      <div class="content">
        <div class="Breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/trademarkSale' }"
              >待售商标</el-breadcrumb-item
            >
            <el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="information">
          <h1>商标信息</h1>
          <div class="body">
            <div class="body_right">
              <ul>
                <li>
                  <span>商标名称: </span>
                  <p>{{ trademarkInfo.name }}</p>
                </li>
                <li>
                  <span>出售价: </span>
                  <p>{{ trademarkInfo.price }}</p>
                </li>
                <li>
                  <span>商标类别: </span>
                  <p>{{ trademarkInfo.category }}</p>
                </li>
                <li>
                  <span>申请号: </span>
                  <p>{{ trademarkInfo.applicationNumber }}</p>
                </li>
                <li>
                  <span>商标状态: </span>
                  <p>{{ trademarkInfo.status }}</p>
                </li>
                <li>
                  <span>商标结构: </span>
                  <p>{{ trademarkInfo.structure }}</p>
                </li>
                <li>
                  <span>商标关键词: </span>
                  <p>
                    {{ trademarkInfo.keywords }}
                  </p>
                </li>
                <li>
                  <span>商品/服务: </span>
                  <p>
                    {{ trademarkInfo.service }}
                  </p>
                </li>
                <li>
                  <span>联系人: </span>
                  <p>{{ trademarkInfo.contactInfo }}</p>
                </li>
                <li>
                  <span>手机号: </span>
                  <p>{{ trademarkInfo.tel }}</p>
                </li>
              </ul>
            </div>
            <div class="img"><img :src="trademarkInfo.image" alt="" /></div>
          </div>
        </div>
        <div class="Transfer">
          <h1>过户材料</h1>
          <div class="table">
            <table>
              <thead>
                <tr>
                  <th colspan="3">买卖双方需提供材料</th>
                  <th>平台提供</th>
                  <th>过户成功</th>
                </tr>
              </thead>
              <tbody>
                <tr class="one">
                  <td style="width: 128px"></td>
                  <td>公司</td>
                  <td>个人</td>
                  <td>商标代理委托书</td>
                  <td>商标注册证</td>
                </tr>
                <tr>
                  <td style="font-weight: 600; width: 128px">买家</td>
                  <td>企业营业执照</td>
                  <td>身份证 个体户营业执照</td>
                  <td>转让申请书</td>
                  <td>商标转让公证书</td>
                </tr>
                <tr>
                  <td style="font-weight: 600; width: 128px">卖家</td>
                  <td>企业营业执照 商标注册证原件</td>
                  <td>身份证 商标注册证原件</td>
                  <td>转让协议</td>
                  <td>商标转让证明</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="safeguard">
          <h1>服务保障</h1>
          <ul>
            <li>
              <div
                class="block"
                style="background-color: #e7f8f8; color: #49a5a5"
              >
                智能<br />匹配
              </div>
              <h1>智能匹配买卖</h1>
              <p>通过大数据精准分析</p>
              <p>为每个商标卖家找到精准买家</p>
            </li>
            <li>
              <div
                class="block"
                style="background-color: #e2ecfc; color: #3a7ee9"
              >
                价格<br />透明
              </div>
              <h1>价格透明、自由议价</h1>
              <p>由卖方直接报价</p>
              <p>买方可以提交意向价格给卖方</p>
            </li>
            <li>
              <div
                class="block"
                style="
                  background-color: rgba(241, 180, 72, 0.2);
                  color: #f6ab25;
                "
              >
                自由<br />发布
              </div>
              <h1>买卖方自由发布需求</h1>
              <p>卖方可以发布商标出售需求</p>
              <p>买方也可以发布商标求购需求</p>
            </li>
            <!-- <li>
              <div
                class="block"
                style="background-color: #fbe6e1; color: #e35938"
              >
                交易<br />无忧
              </div>
              <h1>买卖无忧、保障交易</h1>
              <p>通过完善的平台交易系统保障体系</p>
              <p>让买卖双方可以放心交易</p>
            </li> -->
            <li>
              <div
                class="block"
                style="background-color: #fbe6e1; color: #e35938"
              >
                优质<br />服务
              </div>
              <h1>优质服务 保障交易</h1>
              <p>我们提供优质的服务</p>
              <p>买卖双方可以放心交易</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTrademarkDetail } from "../api/userApi";
import service from "../api";
export default {
  data() {
    return {
      trademarkInfo: {
        name: "",
        price: "",
        category: "",
        applicationNumber: "",
        status: "",
        structure: "",
        keywords: "",
        service: "",
        contactInfo: "",
        tel: "",
        image: "", // 默认图片
      },
    };
  },
  methods: {
    getFullImageUrl(url) {
      if (!url) return "";
      if (url.startsWith("http")) return url;
      const baseURL =
        (service && service.defaults && service.defaults.baseURL) || "";
      const normalizedBaseURL = baseURL.replace(/\/$/, "");
      const normalizedPath = url.startsWith("/") ? url : `/${url}`;
      return normalizedBaseURL + normalizedPath;
    },
    async fetchTrademarkDetail() {
      try {
        const res = await getTrademarkDetail({ id: this.$route.query.id });
        if (res.code === 1) {
          this.trademarkInfo = {
            name: res.data.trademark,
            price: res.data.price === 0 ? "面议" : `¥${res.data.price}`,
            category: ` ${res.data.trademark_category_text}`,
            applicationNumber: res.data.application_number,
            status: res.data.trademark_status_text,
            structure: res.data.trademark_structure_text,
            keywords: res.data.keywords,
            service: res.data.service,
            contactInfo: `${res.data.user.contact || "-"}/微信:${
              res.data.user.wechat
            }/QQ:${res.data.user.qq}`,
            tel: res.data.user.tel || "-",
            image: this.getFullImageUrl(res.data.images),
          };
        }
      } catch (error) {
        console.error("获取商标详情失败:", error);
      }
    },
  },
  mounted() {
    this.fetchTrademarkDetail();
  },
};
</script>

<style scoped lang="less">
li {
  list-style: none;
}
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
}
.banner {
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
}
.main {
  background: #f5f5f5;
  padding-bottom: 45px;
  .Breadcrumb {
    padding: 15px 0;
    ::v-deep .el-breadcrumb__inner {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #121212;
    }
  }
  .information {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    padding: 30px;
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 22px;
      color: #0c1223;
      text-align: left;
    }
    .body {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      img {
        width: 258px;
        height: 145px;
        margin-right: 100px;
      }
      .body_right {
        display: flex;
        flex-direction: column;
        ul {
          display: flex;
          flex-direction: column;
          // margin-top: 10px;
          li {
            margin-top: 10px;
            display: flex;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: rgba(18, 18, 18, 0.5);
            span {
              // width: 100px;
              // flex: 1;
              text-align: left;
              white-space: nowrap;
              margin-right: 5px;
            }
            p {
              // margin-left: 5px;
              // width: 70%;
              // flex: 11;
              color: rgba(18, 18, 18, 1);
              text-align: left;
            }
          }
          li:first-child {
            margin-top: 0;
          }
        }

        .img {
          display: flex;
        }
      }
    }
  }
  .Transfer {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    margin-top: 20px;
    padding: 30px;
    padding-right: 50px;
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 22px;
      color: #0c1223;
      text-align: left;
    }
    .table {
      width: 100%;
      margin-top: 10px;
      table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse; /* 合并单元格边框 */
        border-spacing: 0; /* 移除单元格之间的间距 */
        border-radius: 5px;
        th,
        td {
          text-align: center;
          vertical-align: middle;
          position: relative;
        }

        // 如果你想只给特定列加右边框（比如前3列）
        tr td:nth-child(-n + 4)::after,
        tr th:nth-child(-n + 4)::after {
          content: "";
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 1px;
          height: 26px;
          background-color: #dbdbdb;
        }
        tr:first-child th:nth-child(3)::after {
          display: none;
        } 
        thead {
          border: 1px solid #175dc2;
          border-bottom: 0;
          tr {
            height: 50px;
            background: #175dc2;
            border-radius: 5px 5px 0px 0px;
            th {
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
        tbody {
          border-radius: 0px 0px 20px 20px;
          border: 1px solid #efeded;
          border-top: 0;
          .one {
            background: #f2f4fe;
            td {
              font-family: PingFang SC, PingFang SC;
              font-weight: 600;
              font-size: 14px;
              color: #121212;
            }
          }
          tr {
            height: 50px;
            td {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
            }
          }
        }
      }
    }
  }
  .safeguard {
    width: 100%;
    background-color: #fff;
    border-radius: 10px;
    margin-top: 20px;
    padding: 30px;
    h1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 22px;
      color: #0c1223;
      text-align: left;
    }
    ul {
      display: flex;
      justify-content: space-between;
      margin: 15px 10px 0 10px;

      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .block {
          width: 115px;
          height: 115px;
          border-radius: 10px 10px 10px 10px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 26px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 0 auto;
        }
        h1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #3d3d3d;
          margin: 15px 0 5px 0;
          text-align: center;
        }
        p {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #3d3d3d;
          margin-top: 5px;
          text-align: center;
        }
      }
    }
  }
}
</style>
